import './App.css';
import { Country, State, City } from 'country-state-city';
import { useEffect, useState } from 'react';
import CustomList from './components/CustomList';
import axios from 'axios';
import Weather from './components/Weather';

function App() {
  // const countries = Country.getAllCountries()
  const [country, setCountry] = useState({})
  // console.log(country.isoCode)
  const [state, setState] = useState(State.getStatesOfCountry(country))
  const [city, setCity] = useState(City.getCitiesOfState(state))
  const [screen, setScreen] = useState(1)
  const [weather, setWeather] = useState({})

  
  useEffect(() => {
    async function cityWeather(){
      axios.get(`https://api.openweathermap.org/data/2.5/weather?lat=${city.latitude}&lon=${city.longitude}&units=metric&appid=5613893ab575e17dd60a90d6b9ee2c6c`).then((val) => {console.log(val); setWeather(val?.data); setScreen(screen+1)})
    }
    

    cityWeather()
  },[city])
  return (
    <div className="App">
      {
        
        screen<3?
        <CustomList list={screen==1?State.getStatesOfCountry("IN"):City.getCitiesOfState("IN", state.isoCode)} title={screen==1?'Select State':'Select City'}
      setValue={screen==1?setState:setCity}
      screen={screen}
      setScreen={setScreen}
      />:<></>
      }
      {
        screen==3?
        <Weather setScreen={setScreen} weather={weather}/>:<></>
      }
    </div>
  );
}

export default App;
